/**
 * placeTagGroups.ts — Single Source of Truth for place tag grouping.
 * Used by PlaceCoreEditorCard and MatchRulesEditor for consistent taxonomy.
 *
 * SoT: docs/architecture/smart-steering-tag-operators.md
 */

export type PlaceTagGroupKey =
  | 'nature_movement'
  | 'food_taste'
  | 'culture_learning'
  | 'social_family'
  | 'availability';

export interface PlaceTagGroup {
  key: PlaceTagGroupKey;
  icon: string;
  title: string;
  slugs: string[];
}

/** Deprecated slugs that must never appear in UI (season is SoT via best_seasons) */
export const EXCLUDED_TAG_SLUGS = new Set(['aret-runt']);

export const PLACE_TAG_GROUPS: PlaceTagGroup[] = [
  {
    key: 'nature_movement',
    icon: '🌿',
    title: 'Natur & Rörelse',
    slugs: ['naturreservat', 'vandring', 'cykling', 'paddling', 'fiske', 'skidor', 'utsiktsplats', 'rorelse', 'stillhet'],
  },
  {
    key: 'food_taste',
    icon: '🍞',
    title: 'Mat & Smaker',
    slugs: ['smaka', 'cafe', 'gardsbutik', 'marknad'],
  },
  {
    key: 'culture_learning',
    icon: '🎨',
    title: 'Kultur & Lärande',
    slugs: ['kultur-historia', 'museum', 'hantverk', 'konsert', 'guidning', 'workshop', 'lara'],
  },
  {
    key: 'social_family',
    icon: '👨‍👩‍👧‍👦',
    title: 'Socialt & Familj',
    slugs: ['familj', 'barnvanligt', 'umgas', 'lek'],
  },
  {
    key: 'availability',
    icon: '🗓',
    title: 'Tillgänglighet',
    slugs: ['lugn-helg'],
  },
];

/** All grouped slugs as a Set for quick lookup */
export const ALL_GROUPED_SLUGS = new Set(PLACE_TAG_GROUPS.flatMap((g) => g.slugs));
